import React, { Component } from 'react';
import { DakshStatus } from '../../../global/Enum';


class TitleStatus extends Component {
    render() {
        const { title, status } = this.props;
        return (
            <h5 className="font mt-0">{title}
                <i className={
                    status === DakshStatus.TO_START ? "customic ic-sale-red" :
                        status === DakshStatus.PENDING ? "customic ic-sale-yellow" :
                            status === DakshStatus.COMPLETED ? "customic ic-sale-green" : "d-none"
                }></i>
                {/* <i className="customic ic-sale-green"></i> */}
                {/* <i class="customic ic-sale-yellow"></i> */}
                {/* <i class="customic ic-sale-red"></i> */}
            </h5>
        )
    }
}

export default TitleStatus;
